// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IsolationUnitSpecInput } from './IsolationUnitSpecInput';
import {
  IsolationUnitSpecInputFromJSON,
  IsolationUnitSpecInputFromJSONTyped,
  IsolationUnitSpecInputToJSON,
  IsolationUnitSpecInputToJSONTyped,
} from './IsolationUnitSpecInput';
import type { MetadataInput } from './MetadataInput';
import {
  MetadataInputFromJSON,
  MetadataInputFromJSONTyped,
  MetadataInputToJSON,
  MetadataInputToJSONTyped,
} from './MetadataInput';

/**
 *
 * @export
 * @interface CreateIsolationUnit
 */
export interface CreateIsolationUnit {
  /**
   *
   * @type {MetadataInput}
   * @memberof CreateIsolationUnit
   */
  metadata?: MetadataInput;
  /**
   *
   * @type {IsolationUnitSpecInput}
   * @memberof CreateIsolationUnit
   */
  spec?: IsolationUnitSpecInput;
}

/**
 * Check if a given object implements the CreateIsolationUnit interface.
 */
export function instanceOfCreateIsolationUnit(
  value: object,
): value is CreateIsolationUnit {
  return true;
}

export function CreateIsolationUnitFromJSON(json: any): CreateIsolationUnit {
  return CreateIsolationUnitFromJSONTyped(json, false);
}

export function CreateIsolationUnitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateIsolationUnit {
  if (json == null) {
    return json;
  }
  return {
    metadata:
      json['metadata'] == null
        ? undefined
        : MetadataInputFromJSON(json['metadata']),
    spec:
      json['spec'] == null
        ? undefined
        : IsolationUnitSpecInputFromJSON(json['spec']),
  };
}

export function CreateIsolationUnitToJSON(json: any): CreateIsolationUnit {
  return CreateIsolationUnitToJSONTyped(json, false);
}

export function CreateIsolationUnitToJSONTyped(
  value?: CreateIsolationUnit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metadata: MetadataInputToJSON(value['metadata']),
    spec: IsolationUnitSpecInputToJSON(value['spec']),
  };
}
